import { createStore } from 'vuex'

export default createStore({
  state: {
    nodeLable: '',
    nodeId: '',
    username:'',
    privilege:'',
    isadmin:'',
    password:'',
    usernickname:'',
    nodeData:  {node:['empty','empty','empty','empty','empty','empty']},////集团，公司，分厂，装置，设备Uuid, ,
    treeWidth: '230px',
    contentWidth: '270px',
    flag: true
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
